import { ardoizLogoV2 } from "assets/images/brand"
import { visio } from "assets/images/illustrations"
import Button from "components/atoms/Button/Button"
import { FormattedMessage } from "react-intl"
import Route from "routes/Routes"
import { navigate } from "utils"

const VideoCallExpired = (): JSX.Element => {
  return (
    <div className="flex flex-col  gap-4w justify-center items-center">
      <div className="flex justify-center w-full py-2w border-b border-grey-200">
        <img src={ardoizLogoV2} alt="Ardoiz" />
      </div>
      <h1 className="text-header3">
        <FormattedMessage id="videoCall.call.notfound.title" />
      </h1>
      <img className="size-[178px]" alt="visio illustration" src={visio}></img>
      <h2 className="text-header5">
        <FormattedMessage id="videoCall.call.notfound.subtitle" />
      </h2>
      <p className="text-body1">
        <FormattedMessage id="videoCall.call.notfound.description" />
      </p>
      <Button onClick={() => navigate(Route.HOME, { hasSelectedChannelParam: false })}>
        <FormattedMessage id="videoCall.call.notfound.backtohome" />
      </Button>
    </div>
  )
}

export default VideoCallExpired;